var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"content-inner-wrapper"},[_c('ServerOrder',{attrs:{"currServs":_vm.currServers}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }